__turbopack_context__.v({
  "code-block-error-icon": "CodeBlockErrorIndicator-module__9XYrXa__code-block-error-icon",
  "code-block-error-tooltip": "CodeBlockErrorIndicator-module__9XYrXa__code-block-error-tooltip",
  "code-block-error-tooltip-inner": "CodeBlockErrorIndicator-module__9XYrXa__code-block-error-tooltip-inner",
  "editor-code-highlight": "CodeBlockErrorIndicator-module__9XYrXa__editor-code-highlight",
  "editor-code-line": "CodeBlockErrorIndicator-module__9XYrXa__editor-code-line",
  "unclosed-block-pulse": "CodeBlockErrorIndicator-module__9XYrXa__unclosed-block-pulse",
});
